import { z } from 'zod';
export const createTransferSchema = z.object({
    submission_date: z.string().nullable().optional(),
    client_reference: z.string().nullable().optional(),
    from_account_number: z.string().min(1, 'From account number is required'),
    to_account_title: z.string().nullable().optional(),
    to_account_number: z.string().min(1, 'To account number is required'),
    product_code: z.string().min(1, 'Product code is required'),
    item_quantity: z.number().positive('Quantity must be greater than 0'),
    to_ira_custodian: z.string().nullable().optional(),
    is_ira_account: z.enum(['Y', 'N']).default('N'),
    notes: z.string().nullable().optional(),
}).refine((data) => {
    if (data.is_ira_account === 'N') {
        return /^\d+$/.test(data.to_account_number);
    }
    return true;
}, { message: 'Non-IRA account numbers must be numeric', path: ['to_account_number'] });
export const updateTransferSchema = z.object({
    submission_date: z.string().nullable().optional(),
    client_reference: z.string().nullable().optional(),
    from_account_number: z.string().min(1).optional(),
    to_account_title: z.string().nullable().optional(),
    to_account_number: z.string().min(1).optional(),
    product_code: z.string().min(1).optional(),
    item_quantity: z.number().positive().optional(),
    to_ira_custodian: z.string().nullable().optional(),
    is_ira_account: z.enum(['Y', 'N']).optional(),
    notes: z.string().nullable().optional(),
});
//# sourceMappingURL=transfer.js.map